export const FETCH_TRENDS_BEGIN = 'FETCH_TRENDS_BEGIN';
export const FETCH_TRENDS_SUCCESS = 'FETCH_TRENDS_SUCCESS';
export const FETCH_TRENDS_FAILURE = 'FETCH_TRENDS_FAILURE';
export const CHANGE_TREND_VALUE = 'CHANGE_TREND_VALUE';
export const RESET_STATE = 'RESET_STATE';
